// extracted by mini-css-extract-plugin
module.exports = {"caption":"carousel-module--caption--2kfby","item":"carousel-module--item--AIX81"};